import React, {useEffect} from "react";
import {View, Text, StyleSheet, TouchableOpacity} from "react-native";
import {useDispatch, useSelector} from "react-redux";
import {globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Button} from "../../../components/core/Button";
import {showLoader} from "../../../commonComponents/Loader/loader.actions";
import LiquidityFields from "./liquidityFields";

const PortfolioRemoveLiquidity = ({
  item: probeId,
  onSellCancelClick,
  navigation,
  contestId,
}) => {
  const dispatch = useDispatch();
  let probe = useSelector(
    ({portfolioReducer}) => portfolioReducer?.liquidityDetail[probeId],
  );
  let liquidity = probe;

  let newSellPriceYes = probe?.newSellPriceYes;

  let newSellPriceNo = probe?.newSellPriceNo;

  newSellPriceNo = newSellPriceNo
    ? parseFloat(newSellPriceNo).toFixed(2)
    : null;
  newSellPriceYes = newSellPriceYes
    ? parseFloat(newSellPriceYes).toFixed(2)
    : null;

  const onPortfolioTitlecClick = () => {
    dispatch(showLoader());
    if (contestId) {
      navigation.navigate("ContestEvents", {
        contestId: contestId,
        eventId: probe?.id,
        isMulti: probe?.parent_id === -1 ? true : false,
        probeInfo: probe,
      });
    } else {
      navigation.navigate("Event", {
        eventId: probe?.id,
        isMulti: probe?.parent_id === -1 ? true : false,
        probeInfo: probe,
      });
    }

    //navigation.navigate("Event", { eventData: probe, probeInfo: probe });
  };
  return (
    <View>
      <View style={[globalStyle.cardContainer, {paddingHorizontal: 0}]}>
        <View style={{paddingHorizontal: 15}}>
          <TouchableOpacity
            style={styles.upperRow}
            onPress={onPortfolioTitlecClick}>
            <Text
              style={[
                globalFontStyle.appFontSubHeading,
                {color: Colors.black, flexWrap: "wrap", flex: 1},
              ]}
              numberOfLines={3}>
              {probe?.title}
            </Text>
          </TouchableOpacity>
        </View>

        <View
          style={{
            marginTop: 15,
            flex: 1,
            borderTopWidth: 0.75,
            borderTopColor: Colors.borderColor,
          }}
        />

        {liquidity ? <LiquidityFields liquidity1={liquidity} /> : null}
        <View style={{paddingHorizontal: 15, flexDirection: "row"}}>
          <Button
            variant="rm-liquidity"
            size="default"
            onPress={() => onSellCancelClick({probe, isRemoveShare: true})}
            style={[
              styles.btnExternalStyle,
              {
                marginTop: 15,
              },
            ]}
            translate={true}
          >
            Remove Shares
          </Button>
        </View>
      </View>
    </View>
  );
};

export default React.memo(PortfolioRemoveLiquidity);

const styles = StyleSheet.create({
  cardImg: {
    width: 60,
    height: 60,
    marginRight: 15,
  },
  upperRow: {
    flexDirection: "row",
    alignItems: "center",
  },

  btnExternalStyle: {
    borderColor: "#0A5881",
    borderWidth: 0.2,
    paddingVertical: 8,
    width: 150,
  },
});
